import { Constructor } from '@angular/cdk/table';
import { FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

type WithUrlFormSectionType = {
  _initUrl(url: string): void;
  _initUrlValueChanges(getPreviousUrl: () => string | null): void;
  _buildUrl(): string;
};

type UrlFormSectionRequerimentsBase = {
  form: FormGroup;
  FORM_PATHS: { URL: () => string };
  destroy$: Subject<boolean>;
};

export function WithUrlFormSection<
  TBase extends Constructor<UrlFormSectionRequerimentsBase>
>(
  baseClass: TBase
): {
  new (...args: any[]): WithUrlFormSectionType;
  prototype: WithUrlFormSectionType;
} & TBase {
  return class WithUrlFormSectionable extends baseClass {
    constructor(...args: any[]) {
      super(...args);
    }

    _initUrl(url: string): void {
      this.form.get(this.FORM_PATHS.URL()).setValue(url);
    }

    _initUrlValueChanges(getPreviousUrl: () => string | null): void {
      this.form
        .get(this.FORM_PATHS.URL())
        .valueChanges.pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (newValue) => {
            if (newValue === getPreviousUrl()) {
              this.form.get(this.FORM_PATHS.URL()).markAsPristine();
            }
          },
        });
    }

    _buildUrl(): string {
      return this.form.get(this.FORM_PATHS.URL()).value;
    }
  };
}
